/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tracking': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="10" r="3"/><path pid="1" d="M20 9h-2.1c-.5-3.6-3.3-6.5-6.9-6.9V0H9v2.1C5.4 2.5 2.5 5.4 2.1 9H0v2h2.1c.5 3.6 3.3 6.5 6.9 6.9V20h2v-2.1c3.6-.5 6.5-3.3 6.9-6.9H20V9zm-10 7c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"/>'
  }
})
